import PatientHistoryTimeline from "@/components/patients/PatientHistoryTimeline";

interface MobileOwnerHistoryTabProps {
  petIds: string[];
  clinicId: string | null;
  includeGrooming: boolean;
}

export function MobileOwnerHistoryTab({ petIds, clinicId, includeGrooming }: MobileOwnerHistoryTabProps) {
  return (
    <PatientHistoryTimeline
      petIds={petIds}
      clinicId={clinicId}
      includeGrooming={includeGrooming}
      timeScope="past"
      hideFutureDetails
      showPetName
    />
  );
}
